import React, { ReactNode } from 'react';

import { JobFormManager } from 'jobs/job-form/job-form.manager';

const EditJobContext = React.createContext<JobFormManager | null>(null);

export const EditJobProvider = ({ children }: { children: ReactNode }) => {
   const [store] = React.useState<JobFormManager>(() => new JobFormManager('EDIT'));

   return <EditJobContext.Provider value={store}>{children}</EditJobContext.Provider>;
};

export const useEditJob = () => {
   const ctx = React.useContext(EditJobContext);
   if (!ctx) {
      throw new Error('useEditJob must be used inside EditJobProvider');
   }
   return ctx;
};
